import CustomApiError from "./CustomApiError"

export default class ForbiddenError extends CustomApiError {
  status = 401
  message = "Forbidden."
}
